import React from "react";
import "./Chip.scss";

const Chip = ({ city, removeSelectedCity, disabled }) => {
  return (
    <div className={`chip ${disabled ? "disabled" : ""}`}>
      <a
        href=""
        className="cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          !disabled && removeSelectedCity(e, city);
        }}
      >
        <span className="city-name">
          {city?.state} ({city?.count})
        </span>
        &nbsp;&nbsp; ✕
      </a>
    </div>
  );
};

export default Chip;
